import React from "react";
import Navbar from "../Navbar/Navbar";

function Quizzes() {
  return (
    <>
      <Navbar />
      <h1 style={{}}>No Quizzes Found.</h1>
    </>
  );
}

export default Quizzes;
